function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clothes-4_svg__id-1a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 215.721C32 184.395 59.187 159 92.723 159h46.554C172.813 159 200 184.395 200 215.721V232H32v-16.279z",
  fill: "#00969F"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 116,
  cy: 162,
  rx: 28,
  ry: 12,
  fill: "#09CAC7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.5 187H68m97.5 22H68m97.5-11H68m97.5 22H68m97.5 11H68m97.5-54s-29.712-1-48.75-1S68 177 68 177m97.5-10s-29.816-3.514-49-3.5C97.51 163.514 68 167 68 167",
  stroke: "#09CAC7",
  strokeWidth: 5,
  strokeLinecap: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clothes-4_svg__id-1a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h232v232H0z"
})));

function SvgClothes4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/clothes-4.dd827a54.svg";
export { SvgClothes4 as ReactComponent };